// extracted by mini-css-extract-plugin
export var errorsContainer = "_ua-1";
export var link = "_ua-0";